/* eslint prefer-destructuring: ["error", {VariableDeclarator: {object: true}}] */
/* eslint no-param-reassign: "error" */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { all } from 'axios';
import { format } from 'date-fns';
import {
  NavItem,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Badge,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { camelCase } from 'lodash';

import { PseudoStates } from '~/components';
import {
  authorizedPyPublicInstance as py,
} from '~/utils';

const statusToColor = status => {
  if (status === 'In Process') {
    return 'info';
  } else if (status === 'Warning') {
    return 'warning';
  } else if (status === 'Ok' || status === 'Complete') {
    return 'success';
  }

  return 'danger';
};

const StatusBadge = ({ label, status }) => (
  <div>
    {label} Status:{' '}

    {status
      ? (
        <Badge
          color={statusToColor(status.attributes[`${camelCase(label)}Status`])}
        >
          {status.attributes[`${camelCase(label)}Status`]}
        </Badge>
      ) : ' N/A'
    }
  </div>
);

StatusBadge.propTypes = {
  label: PropTypes.string.isRequired,
  status: PropTypes.shape({
    attributes: PropTypes.shape().isRequired,
  }),
};

StatusBadge.defaultProps = {
  status: undefined,
};

const LastRefresh = () => {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState('loading');
  const [isPopoverOpen, setIsOpenPopover] = useState(false);
  const [rand, setRand] = useState(0);

  const toggleOpenPopover = () => {
    const o = !isPopoverOpen;

    if (o) {
      setRand(Math.random());
    }

    setIsOpenPopover(o);
  };

  useEffect(() => {
    setStatus('loading');

    py.get('/list_view_cs_tbl_identity_source', {
      params: {
        'lastRefreshDate__!': 'null',
        sort: '-lastRefreshDate',
      },
    })
      .then(r => r.data.data)
      .then(r =>
        all(r.map(source =>
          py
            .get('/tbl_identity_source_status', {
              params: {
                tbl_identity_source_uid: source.id,
                sort: '-createdDate',
                page: 1,
                'page-size': 1,
              },
            })
            .then((rr) => {
              const fData = rr.data.data[0];
              source.attributes.sourceStatus = fData;
              return source;
            }))))
      .then(r => {
        setData(r);
        setStatus('success');
      })
      .catch(() => setStatus('error'));
  }, [rand]);

  return (
    <>
      <NavItem
        active={isPopoverOpen}
        className="nav-link"
        onClick={toggleOpenPopover}
        id="last-refresh"
      >
        <FontAwesomeIcon icon="handshake" fixedWidth size="lg" />
        <span className="d-inline-block d-sm-inline-block d-md-none ml-2">
          Last Updated
        </span>
      </NavItem>

      <Popover
        className="w-100"
        target="last-refresh"
        placement="bottom"
        isOpen={isPopoverOpen}
        toggle={toggleOpenPopover}
      >
        <PopoverBody className={status === 'success' && data.length > 0 && 'p-0'}>
          {status === 'success'
            ? data.length > 0
              ? (
                <ListGroup>
                  {data.map(item => (
                    <ListGroupItem key={item.attributes.sourceName}>
                      <div className="font-weight-bold">
                        {item?.attributes?.sourceName}:{' '}
                        {format(
                          item?.attributes?.lastRefreshDate,
                          'MM/DD/YYYY [at] hh:mm a',
                        )}
                      </div>

                      {[
                        'Sync',
                        // 'File Integrity',
                      ].map(s => (
                        <StatusBadge
                          key={s}
                          label={s}
                          status={item?.attributes?.sourceStatus}
                        />
                      ))}

                      <div className="pt-1">
                        {item?.attributes?.sourceStatus?.attributes?.details &&
                          <span className="text-muted">Details: {item?.attributes?.sourceStatus?.attributes?.details} </span>
                      }
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              ) : <PseudoStates mini status="zero-state" />
            : <PseudoStates mini status={status} />
          }
        </PopoverBody>
      </Popover>
    </>
  );
};

export default LastRefresh;
